import { apis } from 'utils/lib/apis';
import * as VocabularyActions from "./actions";
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
import { sortBy, has } from "lodash";
import axios from "axios"
import configInfo from "config"

const onFilterVocabularyStd = (bookVocabulary, bookId, pageId, currentUser) => {
  let sorted_obj = sortBy(bookVocabulary, [
    function (o) {
      if (o.data && typeof o.data.word === "string") {
        return o.data.word.toLowerCase();
      }
      return "";
    },
  ]);
  return sorted_obj;
};

export const handleListVocabularyCogantes =
  (data, bookId, pageId, currentUser) => async (dispatch) => {
    try {
      const vocabularyRDS = await apis.post(
        "vocabularyRDS",
        `/listVocabularyCognates`,
        {
          body: data,
        }
      );
      let vocabularyupdatasort = onFilterVocabularyStd(
        vocabularyRDS,
        bookId,
        pageId,
        currentUser
      );
      await dispatch(
        VocabularyActions.listVocabularySuccessCogantes(vocabularyupdatasort)
      );
      return vocabularyRDS;
    } catch (error) {
      if (error && error.message != "Network Error") {
        logToSentry({
                message: 'listing vocabulary cogantes',
                error,
                module: 'COGANTES',
                operation: 'LIST_VOCABULARY_CONTENT'
            });
      }
    }
  };

  export const handleListVocabularyCogStud =
    (data, bookId, pageId, currentUser) => async (dispatch) => {
      try {
        const vocabularyRDS = await apis.post(
          "vocabularyRDS",
          `/listVocabularyCognates`,
          {
            body: data,
          }
        );
        return vocabularyRDS;
      } catch (error) {
        if (error && error.message != "Network Error") {
          logToSentry({
                message: 'listing vocabulary cogantes for student',
                error,
                module: 'COGANTES',
                operation: 'LIST_VOCABULARY_CONTENT_FEEDBACK_STUDENT'
            });
        }
      }
    };
  
export const handleAddAndUpdateVocabularyCogantes = (data) => async (dispatch) => {
    await dispatch(VocabularyActions.createVocabularyCongants());
    try {
        const vocabularyData = await apis.post('vocabularyRDS', "/addVocabularyCognates", {
            body: data
        });
        if (data.id) {
            await dispatch(VocabularyActions.updateVocabularySuccessCogantes(vocabularyData));
        } else {
            await dispatch(VocabularyActions.createVocabularySuccessCogantes(vocabularyData));
        }
        return vocabularyData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'adding and updating vocabulary cogantes',
                error,
                module: 'COGANTES',
                operation: 'ADD_ACTIVITY_USER_VIDEO_CONTENT'
            });
        }
    }
};

export const handleGenerateVocabularyCogantes = (data) => async (dispatch) => {
  try {
    const vocabularyData = await apis.post(
      "vocabularyRDS",
      `/generate_vocabulary_cognates`,
      {
        body: data,
      }
    );
    if (vocabularyData && vocabularyData.id) {
      await dispatch(VocabularyActions.createVocabularySuccessCogantes(vocabularyData));
    }
    return vocabularyData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'generating vocabulary cogantes',
                error,
                module: 'COGANTES',
                operation: 'GET_VOCABULARY_CONTENT'
            });
      return null;
    }
  }
};


export const handleDeleteVocabularyCogantes = (id) => async (dispatch) => {
    if (!id) return;
    dispatch(VocabularyActions.deleteVocabularyCogantes())
    try {
        const vocabulary = await apis.del('vocabularyRDS', `/deleteVocabularyCognates/${id}`);
        if (has(vocabulary, "id")) {
            await dispatch(VocabularyActions.deleteVocabularySuccessCogantes(vocabulary));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting vocabulary cogantes',
                error,
                module: 'COGANTES',
                operation: 'DELETE_VOCABULARY_CONTENT'
            });
        }
    }
};
